<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Notificaciones Pendientes</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="row" id="formulario">
            <div class="col-7"></div>
            <div class="col-1"><b>Nombre:</b></div>
            
            <div class="col-3" style="padding-left:0px;padding-right:1px;"><input type="text" v-model="nombreBusqueda" class="form-control" placeholder="Buscar" v-on:keyup.enter="buscarCitas" /></div>
            <div class="col-1" style="padding-left:0px;padding-right:1px;"><button class="form-control" @click="buscarCitas"><i class="fa fa-search"></i></button></div>
          </div>
          <div class="row" id="tabla" style="margin-top:20px;">
            <table class="table table-striped table-light table-hover" id="tablaCitas">
              <thead class="thead-dark">
                <tr class="visible-element">
                  <th>Folio</th>
                  <th>Datos del Solicitante</th>
                  <th>Trámites y Expedientes</th>
                  <th>Fecha y Hora</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for="Cita in Citas">
                  <td>{{Cita.CitaId}}</td>
                  <td>{{Cita.InformacionDeSolicitante.NombreCompleto}}<br />{{Cita.InformacionDeSolicitante.Telefono}}<br />{{Cita.InformacionDeSolicitante.CorreoElectronico}}</td>
                  <td>
                    <ul>
                      <template v-for="Tramite in Cita.TramitesCita">
                        <li>{{Tramite.TipoTramite.Nombre}}.</li>
                        <li style="list-style-type:none"><ul> <li v-for="Expediente in Tramite.Expedientes"> {{Expediente.TipoDocumento_DBPJ.Nombre}} - {{Expediente.NumeroDeExpediente}} </li></ul></li>
                      </template>
                    </ul>

                  </td>
                  <td>{{Cita.AgendaBloque.FechaHoraString}}</td>
                  <td class="d-flex justify-content-around">
                    <i class="fas fa-check-circle fa-2x" @click="confirmarNotificacion(Cita.CitaId)" title="Marcar cita notificada." />
                    <i class="fas fa-envelope fa-2x" title="Reenviar correo de notificación." @click="reenviarCorreo(Cita.CitaId)" />
                  </td>
                </tr>
                <tr v-if="Citas.length == 0"><td colspan="5">No se encontraron citas pendientes en los siguientes 5 días hábiles.</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    data() {
      return {
        Citas: [],
        nombreBusqueda: ""
      }
    },
    components: {
    },
    methods: {
      buscarCitas: function () { //Retorna una lista de citas pendientes de notificar.
        var peticion = {
          "esPrueba": false,
          "NombreBusqueda": this.nombreBusqueda,
          "EstatusCitaId": 2,
          "Notificadas": 0,
          "FechaInicial": null,
          "FechaFinal": null,
          "Hora": null,
          "CargarSoloExpedientesDisponibles": true
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GetCitas, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.Citas = response.data.Citas

            this.$nextTick(() => {
              PaginarTabla('tablaCitas', 60)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      marcarCitaNotificada: function (citaId) { //Marca una cita como notificada manualmente.
        var peticion = {
          "esPrueba": false,
          "CitaId": citaId,
          "Notificada": true
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.MarcarCitaNotificada, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.removerCita(citaId);
            comun.mensajeDeAlerta("Cita marcada como notificada.", null, null)
            this.$nextTick(() => {
              PaginarTabla('tablaCitas', 60)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      confirmarNotificacion: function (citaId) { //Muestra al usuario un mensaje de confirmación para marcar una cita como notificada manualmente.
        var funcion = this.marcarCitaNotificada
        $('.bootbox.modal').modal('hide');
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Seguro que desea marcar la cita con folio "+citaId+" como notificada?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + "No"
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + "Sí"
            }
          },
          callback: function (respuesta) {
            if (respuesta) {
              return funcion(citaId);
            }
          }
        });
      },
      removerCita: function (citaId) {
        var indice = -1;

        this.Citas.forEach(function (cita, index) {
          if (cita.CitaId == citaId) {
            indice = index;

          }
        });
        if (indice > -1) {
          this.Citas.splice(indice, 1);
        }
      },
      reenviarCorreo: function (citaId) {//Redirige a la pantalla de 'ReenviarCorreo'.
        this.$router.push({
          name: 'ReenviarCorreo',
          params: { citaId: citaId }
        })
      }
    }, mounted: function mounted() {
      this.buscarCitas();
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Recepcion/NotificacionesPendientes/NotificacionesPendientes.vue